import React, { useRef } from 'react'
import styles from './Issue.module.scss'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const Issue: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.issue} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.inner}>
        <h2 className={styles.ctsTitle}>
          <span className={styles.ctsTitle__sub}>スマホアプリ開発で、こんな課題に直面していませんか？</span>
        </h2>
        <div className={styles.issueBox}>
          <div className={styles.issueBox__Left}>
            <dl className={styles.issueItem}>
              <dt className={styles.issueItem__title}>リニューアル開発に関するお悩み</dt>
              <dd className={styles.issueItem__text}>アプリの見た目や操作感が古く、ユーザーが離れている気がする</dd>
              <dd className={styles.issueItem__text}>機能追加のたびにコードが複雑化し、改修が重い</dd>
              <dd className={styles.issueItem__text}>デザインと開発が分断され、改善が進まない</dd>
            </dl>
          </div>
          <div className={styles.issueBox__Right}>
            <dl className={styles.issueItem}>
              <dt className={styles.issueItem__title}>新規開発に関するお悩み</dt>
              <dd className={styles.issueItem__text}>
                何から手を付ければ良いのか判断できず、企画そのものが進まずに止まってしまっている
              </dd>
              <dd className={styles.issueItem__text}>社内に開発経験が少なく、進め方に不安がある</dd>
              <dd className={styles.issueItem__text}>リリース後の運用や改善まで見通せない</dd>
            </dl>
          </div>
        </div>
      </div>
    </section>
  )
}
export default Issue
